/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_AudiencesInputs */

const en_directory_footer_link_audiences = /** @type {(inputs: Directory_Footer_Link_AudiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiences`)
};

const zh_directory_footer_link_audiences = /** @type {(inputs: Directory_Footer_Link_AudiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用人群`)
};

/**
* | output |
* | --- |
* | "Audiences" |
*
* @param {Directory_Footer_Link_AudiencesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_audiences = /** @type {((inputs?: Directory_Footer_Link_AudiencesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_AudiencesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_audiences(inputs)
	return zh_directory_footer_link_audiences(inputs)
});
export { directory_footer_link_audiences as "directory.footer.link_audiences" }